<!--
   Sortable column header: shows the label and the up/down arrow, and sends "sort" when clicked.
   Use:  <SortableTh column="firstname" :table-data="tableData" @sort="orderBy">First Name</SortableTh>
   Extra classes (e.g. class="hide-sm-td") and v-if work as on a normal <th>.
-->
<template>
   <th class="button" @click="$emit('sort', column)">
      <slot /> <span><i :class="arrowClass"></i></span>
   </th>
</template>

<script>
export default {
   name: "SortableTh",
   props: {
      // Database column this header sorts by, e.g. "firstname"
      column: { type: String, required: true },
      // The page's tableData (reads currentSortColumn / currentSortDirection)
      tableData: { type: Object, required: true },
   },
   emits: ["sort"],
   computed: {
      // ↕ = not sorted by this column, ↑ = sorted A-Z, ↓ = sorted Z-A
      arrowClass() {
         if (this.tableData.currentSortColumn !== this.column) return "sort-both";
         return this.tableData.currentSortDirection === "ASC" ? "sort-up" : "sort-down";
      },
   },
};
</script>
